import { render, staticRenderFns } from "./ConfigurationSchemaModal.vue?vue&type=template&id=0e2f204a"
import script from "./ConfigurationSchemaModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationSchemaModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationSchemaModal.vue?vue&type=style&index=0&id=0e2f204a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports